type SeriesData = { series?: ReadonlyArray<{ [key: string]: number | undefined }> };

export function hasDataExportUsage(data: SeriesData | undefined): boolean {
  return (data?.series ?? []).some((slice) => (slice['0'] ?? 0) > 0);
}
